<template>
  <data-section
    theme="green"
    title="國泰產險-火險"
    :isFireInsurance="true"
    :datas="
      _.orderBy(
        highlightModify,
        ['familyrl', 'age', 'ceisdno', 'orderbBySelf', 'ceplcno'],
        ['asc', 'desc', 'asc', 'asc', 'asc']
      )
    "
    :_fields="
      [
        {
          name: '保單號碼',
          key: 'ceplcno',
          width: 145,
          sortable: true,
          orderByMultiKey: ['ceplcno'],
          orderByMultiType: ['asc']
        },
        {
          name: '險種',
          key: 'cepln_nm',
          width: 188,
          sortable: true,
          orderByMultiKey: ['cepln_nm'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'ceisdnm',
          width: 94,
          sortable: true,
          className: 'link text-underline',
          orderByMultiKey: ['ceisdnm'],
          orderByMultiType: ['asc']
        },
        {
          name: '有效期間',
          key: 'celpsdt',
          width: 140,
          sortable: true,
          orderByMultiKey: ['celpsdt'],
          orderByMultiType: ['asc']
        },
        {
          name: '主險保費',
          key: 'premium1',
          width: 83,
          sortable: true,
          className: 'text-right',
          orderByMultiKey: ['premium1'],
          orderByMultiType: ['asc']
        },
        {
          name: '附加險總保費',
          key: 'add_prem',
          width: 109,
          sortable: true,
          className: 'text-right',
          orderByMultiKey: ['add_prem'],
          orderByMultiType: ['asc']
        },
        {
          name: '標的地址',
          key: 'address',
          width: 179,
          sortable: true,
          orderByMultiKey: ['address'],
          orderByMultiType: ['asc']
        }
      ].concat(_fields)
    "
    @toggle="
      (isShow) =>
        $router.assignQuery({ CathayPropertyFireInsuranceShow: isShow })
    "
    :initShow="$route.query['CathayPropertyFireInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="props"
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`CathayPropertyFireInsuranceSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`CathayPropertyFireInsuranceSort`]
            ? JSON.parse($route.query[`CathayPropertyFireInsuranceSort`])
            : null
        "
      >
        <template slot="ceplcno" scope="item">
          <span :class="{ 'text-blue': item.data.isKeyinBySelf }">{{
            item.data.ceplcno
          }}</span>
        </template>
        <template slot="celpsdt" scope="item">
          <div
            class="pre-formatted"
            v-html="
              buildStartEndWithTimeString(
                getROCDate(item.data.ceplcdt),
                getROCDate(item.data.celpsdt),
                item.data.ceplcdt_time,
                item.data.celpsdt_time,
              )
            "
          ></div>
        </template>
        <template slot="ceisdnm" scope="item">
          <span @click="routeToCustDetail(item.data.ceisdno , item.data.ceisdnm)">
            {{ item.data.ceisdnm | truncate }}
          </span>
        </template>
        <template slot="premium1" scope="item"
          >{{ item.data.premium1 | numberFormat }}元</template
        >
        <template slot="add_prem" scope="item"
          >{{ item.data.add_prem | numberFormat }}元</template
        >
        <template slot="action" scope="item">
          <a
            role="button"
            class="text-red text-underline"
            @click="doDelete(item.data)"
            >刪除</a
          >
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import HighlightModify from "./HighlightModify";
import { deleteSelfInputPropertyNumber } from "@/service";

export default {
  mixins: [InsuranceMixins, HighlightModify],
  methods: {
    async doDelete(data) {
      await this.$deleteConfirm(
        this.buildDeleteMessage(`${data.ceplcno} ${data.cepln_nm}`)
      );
      await this.deleteSuccessHandler(
        deleteSelfInputPropertyNumber(
          this.$store.state.userInfo.id,
          data.ceplcno,
          ""
        )
      );
      this.isLoading = true;
      this.$bus.emit(
        "cathay-fire-insurance.get",
        () => (this.isLoading = false)
      );
    }
  }
};
</script>
